import Vue from 'vue'
import {
	db
} from '../resources/firebase'
import firebase from 'firebase/app'
import 'firebase/firestore'

export const notificationsMixin = {
	methods: {
		removeFromUserNotifications(targetUser, notificationID) {
			db.collection("test_notifications").doc(targetUser)
				.collection('notifications').doc(notificationID)
				.update({
					"seen": true
				})
				.then(() => {
					this.$store.commit('removeNotification', notificationID)
				})
				.catch((error) => {
					// console.log(error)
					throw new Error(error)
				})
		},
		showNotificationsModal() {
			const html = document.querySelector('html')
			const app = document.querySelector('#app')
			app.classList.add('blur-app')
			html.style.overflowY = 'hidden'

			this.$store.commit('updateNotificationsModal', true)
		}
	}
}



// WEBPACK FOOTER //
// ./src/mixins/notificationsMixin.js